// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1UserSchema } from './v1/userSchema';
import { v1UsersCreateSchema } from './v1/users/createSchema';

export const inviteUserPathParamsSchema = z.object({
  account_id: z.number().int().describe("Workspace id"),
});

export const inviteUserHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description user invited
 */
export const inviteUser200Schema = z.lazy(() => v1UserSchema);

export const inviteUserMutationRequestSchema = z.lazy(() => v1UsersCreateSchema);

export const inviteUserMutationResponseSchema = z.lazy(() => inviteUser200Schema);
